/** Hard character cutoff for a meeting-notes preview. Shared by the student
 *  and counselor details dialogs so both truncate identically. */
export const NOTE_PREVIEW_MAX_CHARS = 40;

/**
 * The notes-row preview for a meeting note — cut at the first line break if
 * there is one before the character cap, otherwise cut at the cap. A hard
 * slice rather than a CSS ellipsis, so a counselor's whitespace formatting
 * (headers, blank lines) survives exactly instead of being collapsed by the
 * browser's default text rendering.
 * @param {string | null} note
 * @returns {string}
 */
export function notePreview(note: string | null): string {
  const text = note ?? '';
  const newlineIndex = text.indexOf('\n');
  const limit =
    newlineIndex === -1 ? NOTE_PREVIEW_MAX_CHARS : Math.min(newlineIndex, NOTE_PREVIEW_MAX_CHARS);
  return text.slice(0, limit);
}

/** Whether notePreview actually cut anything — controls a trailing "…". */
export function notePreviewTruncated(note: string | null): boolean {
  return (note ?? '').length > notePreview(note).length;
}
